// Copyright 1999-2018. Plesk International GmbH. All rights reserved.

import { createElement } from '../../utils';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';

import '../../helpers/base.less';
import './Spinner.less';

/**
 * `Spinner` component.
 */
const Spinner = ({ baseClassName, className, ...props }) => (
    <svg
        className={classNames(baseClassName, className)}
        {...props}
        viewBox="0 0 48 48"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle
            className={`${baseClassName}__path`}
            fill="none"
            strokeWidth="6"
            strokeLinecap="round"
            cx="24"
            cy="24"
            r="21"
        />
    </svg>
);

Spinner.propTypes = {
    /**
     * @ignore
     */
    baseClassName: PropTypes.string,
    /**
     * @ignore
     */
    className: PropTypes.string,
};

Spinner.defaultProps = {
    baseClassName: `${CLS_PREFIX}spinner`,
    className: null,
};

export default Spinner;



// WEBPACK FOOTER //
// ./components/Spinner/Spinner.js